module.exports = __webpack_public_path__ + "img/Difarmer-bolsa-de-trabajo.376a8247.png";